document.addEventListener('DOMContentLoaded', () => {
    const minusBtn = document.querySelector('.qty-selector__btn--minus');
    const addBtn = document.querySelector('.qty-selector__btn--add');
    const quantityInput = document.querySelector('#product-quantity');

    if (minusBtn && addBtn && quantityInput) {
        minusBtn.addEventListener('click', () => {
            let currentValue = parseInt(quantityInput.value, 10);
            if (currentValue > 1) {
                quantityInput.value = currentValue - 1;
            }
        });

        addBtn.addEventListener('click', () => {
            let currentValue = parseInt(quantityInput.value, 10);
            quantityInput.value = currentValue + 1;
        });
    }
});